import { Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import HeaderComponent from '../../components/HeaderComponent';
import { getFeaturedNetworkCenters } from '../../services/api/cashless-vaccination';
import SidebarComponent from '../../components/sidebarComponent';

export default function FeaturedCenterCitySelection(props) {
  const { history = {} } = props;
  const [featuredCentersList, setFeaturedCenterList] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState();
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    fetchFeaturedNetworkCenters();
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  }

  useEffect(() => {
    const uniqueCity = [
      ...new Set(featuredCentersList.map((item) => item.city.trim())),
    ];
    setCities(uniqueCity);
  }, [featuredCentersList]);

  useEffect(() => {
    if (selectedCity) {
      history.push('/featured-centers', {
        selectedCity: selectedCity,
      });
    }
  }, [selectedCity]);

  const fetchFeaturedNetworkCenters = () => {
    return getFeaturedNetworkCenters()
      .then((response) => {
        setFeaturedCenterList(response.body.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };

  return (
    <>
      <Layout>
        <div>
          <HeaderComponent />
          <div style={{
            display: 'flex',
          }}>
            <div style={{ zIndex: 1000 }}>

              <SidebarComponent isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}/>
            </div>
            <div>


        <div style={{ margin: '20px' }}>
          <label>Please Select City : </label>
          <select
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
          >
            <option value={''}>Select City</option>
            {cities.map((item) => (
              <option value={item}>{item}</option>
            ))}
          </select>
        </div>
        </div></div></div>
      </Layout>
    </>
  );
}
